const flowNames = {
    CHECKOUT_WITH_HOME_ADDRESS: 'CHECKOUT_WITH_HOME_ADDRESS',
    CHECKOUT_NO_HOME_ADDRESS: 'CHECKOUT_NO_HOME_ADDRESS',
};

export default flowNames;
